import { useEffect, useState } from 'react';
import { withForcedLedgerReadMode } from '../utils/ledgerReadMode';
import { authFetch } from '../lib/authFetch';

type UseTransactionCategoriesOptions = {
  type?: 'income' | 'expense' | 'savings';
};

export const useTransactionCategories = (options: UseTransactionCategoriesOptions = {}) => {
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const query = new URLSearchParams();
        if (options.type) query.set('type', options.type);
        const path = query.toString()
          ? `/api/transactions/categories?${query.toString()}`
          : '/api/transactions/categories';

        const res = await authFetch(withForcedLedgerReadMode(path), {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (res.ok) {
          const data = await res.json();
          setCategories(data);
        }
      } catch (err) {
        console.error('Failed to load categories:', err);
      }
    };

    fetchCategories();
  }, [options.type]);

  return { categories };
};
